import * as React from "react"
import ProjectCard from "./projectCard"
import Spacer from "../components/spacer"

const FeaturedProjects = ({projects}) => {
  return (
  <div className='featured--projects p10'>
    <div className='flex'>
      <div className='w-50 pr10'>
        <div className='w-66'>
          <ProjectCard project={projects[0]}  />
        </div>
      </div>
      <div className='w-50 pl10'>
        <ProjectCard project={projects[1]}  />
      </div>
    </div>
    <Spacer />
    <ProjectCard ratio={projects[2].featuredRatio} project={projects[2]}  />
    <Spacer />
    <Spacer className='m-hide' />
    <div className='flex'>
      <div className='w-50 pr10'>
        <ProjectCard project={projects[3]}/>
      </div>
      <div className='w-50 pl10'>
        <div className='w-66 mla'>
          <ProjectCard project={projects[4]}/>
        </div>
      </div>
    </div>
  </div> 
  )
} 
export default FeaturedProjects
